<template>
  <v-snackbar v-model="resource.display" timeout="3000" color="success">
    {{ resource.message }}

    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
        Fechar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    resource: {
      type: [Array, Object, String],
      default: () => ({}),
    },
  },
};
</script>

<style></style>
